import { magicLinkClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

type AuthError = {
  message?: string;
};

type AsyncResult<T> = Promise<{
  data?: T | null;
  error?: AuthError | null;
}>;

type SessionData = {
  session: {
    activeOrganizationId?: string | null;
    expiresAt: Date;
    id: string;
    token: string;
    userId: string;
  };
  user: {
    email: string;
    emailVerified: boolean;
    id: string;
    image?: string | null;
    name?: string | null;
    role?: string | null;
  };
};

type AuthHookResult<T> = {
  data?: T | null;
  error?: AuthError | null;
  isPending: boolean;
  refetch?: () => void;
};

export type NubankAuthClient = {
  signIn: {
    magicLink: (input: {
      callbackURL?: string;
      email: string;
      errorCallbackURL?: string;
      name?: string;
    }) => AsyncResult<unknown>;
  };
  signOut: () => AsyncResult<unknown>;
  useSession: () => AuthHookResult<SessionData>;
};

export const authClient = createAuthClient({
  plugins: [magicLinkClient()],
}) as unknown as NubankAuthClient;
